import React, { useEffect, useState } from "react";
import * as FaIcons from "react-icons/fa";
import * as MdIcons from "react-icons/md";

const allIcons = { ...FaIcons, ...MdIcons };

export default function SelectIcon({ ControllerProps, dispatchItemToredux }) {
  const { title, reduxKey } = ControllerProps;
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedIcon, setSelectedIcon] = useState(null);
  // console.log(selectedIcon);
  const [icons, setIcons] = useState([]);
  // console.log(icons);
  // console.log(searchTerm);
  // console.log(title);

  useEffect(() => {
    if (selectedIcon) {
      dispatchItemToredux(selectedIcon, reduxKey);
    }
  }, [selectedIcon]);

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchTerm(value);
    if (value) {
      const filteredIcons = Object.keys(allIcons).filter((icon) =>
        icon.toLowerCase().includes(value.toLowerCase())
      );
      setIcons(filteredIcons);
    } else {
      setIcons([]);
    }
  };

  const handleIconSelect = (iconName) => {
    setSelectedIcon(iconName);
  };
  //renderIcon
  const renderIcon = (iconName) => {
    const IconComponent = allIcons[iconName];
    return <IconComponent className="font-light" />;
  };

  return (
    <div className="icon-search-select">
      <label htmlFor="" className="font-light w-[50%] text-left truncate">{title}</label>
      <input
        type="text"
        placeholder="Search icons..."
        value={searchTerm}
        onChange={handleSearchChange}
        className="border p-1 w-[96.5%] rounded"
      />
      {searchTerm && (
        <div className="icon-results w-full h-40 flex flex-wrap items-center justify-between overflow-hidden overflow-y-auto">
          {icons.map((iconName) => (
            <button
              key={iconName}
              onClick={() => handleIconSelect(iconName)}
              className="icon-button w-[13%] flex items-center justify-left gap-1 font-light text-xl"
            >
              {renderIcon(iconName)}
            </button>
          ))}
        </div>
      )}
      {/* {selectedIcon && (
        <div className="w-full flex items-center justify-left gap-1 font-light ">
          <h3 className="font-light">Selected Icon:</h3>
          {renderIcon(selectedIcon)}
        </div>
      )} */}
    </div>
  );
}
